const partnerContent = {
  title: '파트너 관리 매뉴얼',
  content: `
  <div class="page-title">[파트너 관리]</div>

# [개요]
파트너 관리 기능은 웹사이트의 파트너사 정보를 효율적으로 관리하기 위한 도구입니다. 이 문서에서는 **파트너사의 등록, 수정, 조회 등 전반적인 관리 방법**을 확인할 수 있습니다.

### 📋 주요 기능 요약
| 기능 | 설명 | 권한 |
|------|------------------|------------|
| 파트너 조회 | 카테고리별 파트너사 목록 확인 | 관리자 |
| 파트너 등록 | 신규 파트너사 정보 등록 | 관리자 |
| 순서 관리 | 카테고리 내 파트너사 순서 변경 | 관리자 |

# [조회]
등록된 파트너사를 카테고리별로 조회하고 관리할 수 있습니다.

### 📋 화면 구성 및 기능
| 영역 | 구성 | 주요 기능 |
|------|------|-----------|
| 목록 영역 | 파트너 목록 | • 카테고리별 그룹핑<br>• 로고 이미지 표시<br>• 순서 변경 기능 |
| 순서 관리 | 드래그 앤 드롭 영역 | • 카테고리 내 파트너사 순서 변경<br>• 실시간 순서 저장 |

> 💡 **Tip**
> - 같은 카테고리 내에서 드래그 앤 드롭으로 순서를 변경할 수 있습니다.
> - 순서 변경 시 실시간으로 저장됩니다.

![파트너 목록](/assets/images/guide/partner/list.png)

# [등록/수정]
파트너사를 신규 등록하거나 기존 파트너사의 상세 정보를 수정할 수 있습니다.

### 📋 화면 구성 및 기능
| 영역 | 입력 항목 | 설명 |
|------|-----------|------|
| 기본 정보 | • 파트너 카테고리<br>• 파트너명<br>• 사용 여부 | • 카테고리 선택<br>• 회사명 입력<br>• 노출 여부 설정 |
| 이미지 설정 | • 로고 이미지 | • 목록 노출용 로고<br> |

> ⚠️ **주의사항**
> - 파트너명과 로고 이미지는 필수 입력 항목입니다.
> - 이미지는 권장 사이즈에 맞게 업로드해야 합니다.

![파트너 등록](/assets/images/guide/partner/edit.png)
  `,
};

export default partnerContent;
